import * as React from 'react'
import { safeBoolean } from '../../utils/utils'
import { Badge, badges } from 'DVWebNodeUI'

export interface UhdBadgeProps {
  isUhd?: boolean
}

export const Uhd = ({ isUhd }: UhdBadgeProps) => (
  safeBoolean(isUhd) &&
  (<Badge use={badges.BORDERED_TEXT}>
    <span data-automation-id="uhd-badge">UHD</span>
  </Badge>) || null
)
